type Env = 'local' | 'staging' | 'production';

export const getEnv = (): Env => {
  if (window?.location?.port === '3333') {
    return 'local';
  }
  if (window?.location?.href.includes('2auxk5mvn')) {
    return 'staging';
  }
  return 'production';
};
